import { httpGetAuthToken } from '@iconik-io/iconik-api/src/services/auth';

import { skipTokenRefresh } from '../middlewares/http/actions';
import { createAppThunk } from '../types';

export const verifyToken = createAppThunk(
  () => (dispatch) => dispatch(skipTokenRefresh(httpGetAuthToken())),
);
